export default __webpack_public_path__ + "static/media/product-8.8e23a1e3.jpg";